import React, { useState } from 'react';
import Header from '../component/Header';
import ChatWithAI from '../component/ChatWithAI';
import Sidebar from '../component/Sidebar';


const ChatAI = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => { 
        setIsSidebarOpen(!isSidebarOpen);
    };
 
    return (
        <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
            {/* Sidebar with conditional rendering for mobile */}
            <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-1/6 fixed left-0 top-0 h-full z-50`}>
                <Sidebar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            </div>

            {/* Overlay for mobile when sidebar is open */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                ></div>
            )}

            <div className='flex flex-col w-full space-y-4 lg:ml-[16.67%]'>
                <div>
                     <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} 
                     title='AI Consultation'
                     />  
                </div>

                <div className='h-full w-full'>
                 <ChatWithAI />
                </div>
            </div>
        </div>
    )
}

export default ChatAI
